import React,{useEffect} from "react";
import { ProfileTabs } from "../components";
import { useSelector , useDispatch} from "react-redux";
import { setNavbarDark } from '../../src/appState/slices/auth/authSlice';

const Profile = () => {
    const user = useSelector(state => state.auth.user);
    const dispatch = useDispatch()
    useEffect(() => {
        // dispatch(setNavbarDark(true));
      });
    return(
        <div className="cartcontainer profile-padding">
            <div className="profile-name">
            <div className="t3 font-medium">Hi</div>
            <div className="t1 font-extrabold">{user? user.name : null}</div>
            </div>
            <ProfileTabs />
        </div>
    )
}

export default Profile;